import { InventoryStatus, ToolCheckInItemsInput, ToolInventory } from '@bechtel/ht-types';
import { createContext, useState } from 'react';
import { actionType } from './types';

export type ToolInventoryWithQuantity = ToolInventory & {
  quantity?: number;
};

type ReturnContextType = {
  selectedCheckInToolList: ToolInventoryWithQuantity[] | null;
  selectedIds: ToolCheckInItemsInput[] | null;
  updateData: (
    type: actionType,
    payload: { checkInToolList?: ToolInventoryWithQuantity[]; statusCode?: InventoryStatus; comments?: string }
  ) => void;
};

export const ReturnToolContext = createContext<ReturnContextType>({} as ReturnContextType);

const ReturnContextWapper = ({ children }) => {
  const [selectedCheckInToolList, setSelectedCheckInToolList] = useState<ToolInventoryWithQuantity[] | null>(null);
  const [selectedIds, setSelectedIds] = useState<ToolCheckInItemsInput[] | null>(null);

  const getIndex = (item: ToolInventoryWithQuantity) => {
    if (!selectedIds) {
      return -1;
    }
    return (
      selectedIds && selectedIds.findIndex((oldList: ToolCheckInItemsInput) => oldList.toolInventoryId === item.id)
    );
  };
  const updateData = (
    type: actionType,
    payload: { checkInToolList?: ToolInventoryWithQuantity[]; statusCode?: InventoryStatus; comments?: string }
  ) => {
    let oldState: ToolInventoryWithQuantity[] | null = selectedCheckInToolList
      ? JSON.parse(JSON.stringify(selectedCheckInToolList))
      : [];
    let oldSelectedIds: ToolCheckInItemsInput[] | null = selectedIds ? JSON.parse(JSON.stringify(selectedIds)) : [];
    const toolCheckinList: ToolInventoryWithQuantity[] = payload.checkInToolList ?? [];

    switch (type) {
      case actionType.ADD:
      case actionType.ADDLL:
        if (toolCheckinList && toolCheckinList.length > 0) {
          toolCheckinList.map((item: ToolInventoryWithQuantity) => {
            const index = getIndex(item);
            if (index == -1 && oldState && oldSelectedIds && item) {
              oldState.push(item);
              oldSelectedIds.push({
                toolInventoryId: item.id,
                statusCode: InventoryStatus.GOOD,
                quantity: item.quantity ?? 1,
                toolCatalogId: item.toolCatalogId,
              });
            }
          });
        }
        break;
      case actionType.REMOVE:
        if (toolCheckinList && toolCheckinList.length > 0) {
          toolCheckinList.map((item: ToolInventoryWithQuantity) => {
            const index = getIndex(item);
            if (index != -1 && oldState && oldSelectedIds && item) {
              oldState.splice(index, 1);
              oldSelectedIds.splice(index, 1);
            }
          });
        }
        break;
      case actionType.UPDATE_STATUS:
        if (toolCheckinList && toolCheckinList.length > 0) {
          toolCheckinList.map((item: ToolInventoryWithQuantity) => {
            const index = getIndex(item);
            if (index != -1 && oldState && oldSelectedIds && item) {
              oldSelectedIds[index].statusCode = payload.statusCode ?? InventoryStatus.GOOD;
            }
          });
        }
        break;
      case actionType.INCREMENT_QUANTITY:
        if (toolCheckinList && toolCheckinList.length > 0) {
          toolCheckinList.map((item: ToolInventoryWithQuantity) => {
            const index = getIndex(item);
            if (index != -1 && oldState && oldSelectedIds && item) {
              oldSelectedIds[index].quantity = oldSelectedIds[index].quantity + 1;
            }
          });
        }

        break;
      case actionType.Decrement_QUANTITY:
        if (toolCheckinList && toolCheckinList.length > 0) {
          toolCheckinList.map((item: ToolInventoryWithQuantity) => {
            const index = getIndex(item);
            if (index != -1 && oldState && oldSelectedIds && item) {
              oldSelectedIds[index].quantity = oldSelectedIds[index].quantity - 1;
            }
          });
        }
        break;
      case actionType.RESET_ALL:
        oldState = null;
        oldSelectedIds = null;
        break;
      case actionType.ADD_COMMENT:
        if (toolCheckinList && toolCheckinList.length > 0) {
          toolCheckinList.map((item: ToolInventoryWithQuantity) => {
            const index = getIndex(item);
            if (index != -1 && oldState && oldSelectedIds && item) {
              oldSelectedIds[index].comments = payload.comments;
            }
          });
        }

        break;
    }

    setSelectedCheckInToolList(oldState);
    setSelectedIds(oldSelectedIds);
  };

  return (
    <ReturnToolContext.Provider value={{ selectedCheckInToolList, selectedIds, updateData }}>
      {children}
    </ReturnToolContext.Provider>
  );
};

export default ReturnContextWapper;
